import RejectDisplay from './RejectDisplay'
import RejectForm from './RejectForm.container'
import IconBlock from 'components/Icons/Block'

export default {
  id: 'reject',
  label: 'Reject Call',
  helpUrl: 'https://help.thinkpickle.com.au/flows/actions/reject-call',
  icon: IconBlock,
  inputs: [{}],
  outputs: [],
  display: RejectDisplay,
  form: RejectForm,
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/Reject/index.js